import QuestionType from "../../utils/generalFormUtils";
import InputCheckBoxGroup from "./input-checkbox.template";
import InputRadioGroup from "./input-radio-group.template";
import InputOpen from "./input-open.template";

const QuestionComponents = {
  [QuestionType.TEXT]: InputOpen,
  [QuestionType.CHECKBOX]: InputCheckBoxGroup,
  [QuestionType.RADIO]: InputRadioGroup,
};

const Question = ({ question, answer, onAnswerChange }) => {
  if (!question?.content?.content?.question) {
    return null;
  }

  const { type, content, id } = question;
  const questionData = content.content.question;
  const questionId = id;
  const options = questionData.options || [];

  const Component = QuestionComponents[type];

  // Specific validations by type, for example: if a checkbox or radio question has no options, it should not be rendered.
  const isSkippable =
    (type === QuestionType.CHECKBOX || type === QuestionType.RADIO) &&
    options.length === 0;

  if (!Component || isSkippable) {
    return null;
  }

  return (
    <div style={{ marginBottom: "1rem" }}>
      <Component
        question={questionData}
        answer={answer}
        onAnswerChange={onAnswerChange}
        id={questionId}
      />
    </div>
  );
};

export default Question;
